import React from 'react';
import { Card } from '@material-ui/core';
import {
  dayMap,
  orderDays,
  deserializePlanning,
  minutesBetween,
  toHumanDuration,
  hmsToMinutes,
} from './planningUtils';

// eslint-disable-next-line react/prop-types
const ContractualPlanningSlotsGrid = ({ serialized, totalWorkTime }) => {
  const planning = deserializePlanning(serialized);

  const assignedMinutes = orderDays.reduce((acc, d) => {
    const shifts = Array.isArray(planning?.[d]) ? planning[d] : [];
    const dayMinutes = shifts
      .filter((s) => {
        return s && s.start && s.end;
      })
      .reduce((sum, s) => {
        return sum + minutesBetween(s.start, s.end);
      }, 0);
    return acc + dayMinutes;
  }, 0);

  const totalWorkMinutes = hmsToMinutes(totalWorkTime);
  const columnStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 120,
    flex: 1,
  };
  const slotStyle = {
    height: 36,
    borderRadius: 6,
    background: '#f3f6f9',
    border: '1px solid #d6dde6',
    padding: '4px 8px',
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#1f2d3d',
  };
  const headerStyle = {
    fontWeight: 600,
    fontSize: 13,
    marginBottom: 6,
    textAlign: 'center',
  };

  const grid = (
    <div
      style={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 12,
      }}
    >
      {orderDays.map((d) => {
        const shifts = Array.isArray(planning?.[d]) ? planning[d] : [];
        const dayMinutes = shifts
          .filter((s) => {
            return s && s.start && s.end;
          })
          .reduce((sum, s) => {
            return sum + minutesBetween(s.start, s.end);
          }, 0);
        return (
          <div
            key={d}
            style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <div style={headerStyle}>{dayMap[d]}</div>
            <div style={columnStyle}>
              {shifts.length === 0 && (
                <div
                  style={{
                    fontSize: 12,
                    color: '#98a6b3',
                    textAlign: 'center',
                  }}
                >
                  —
                </div>
              )}
              {shifts
                .filter((s) => {
                  return s && s.start && s.end;
                })
                .slice()
                .sort((a, b) => {
                  return a.start.localeCompare(b.start);
                })
                .map((s, idx) => {
                  const mins = minutesBetween(s.start, s.end);
                  const label = `${toHumanDuration(mins)} · ${s.start}-${
                    s.end
                  }`;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`${d}-${idx}`} style={slotStyle}>
                      <span>{label}</span>
                    </div>
                  );
                })}
            </div>
            <div
              style={{
                marginTop: 8,
                textAlign: 'center',
                fontSize: 12,
                color: '#506174',
              }}
            >
              Total: {toHumanDuration(dayMinutes)}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <Card style={{ padding: '0.75rem 1rem', width: '100%' }}>
      <h3
        style={{
          margin: '0 0 1.2rem  0',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '1.4rem',
          lineHeight: '1.5rem',
          letterSpacing: '-0.015em',
        }}
      >
        {'Planning Contractuel — '}
        <span
          style={{
            color:
              // eslint-disable-next-line no-nested-ternary
              assignedMinutes === totalWorkMinutes
                ? 'green'
                : assignedMinutes > totalWorkMinutes
                ? 'red'
                : 'orange',
          }}
        >
          {toHumanDuration(assignedMinutes)} /
          {toHumanDuration(totalWorkMinutes || 0)}
        </span>
      </h3>
      <div style={{ display: 'flex', width: '100%' }}>{grid}</div>
    </Card>
  );
};

export default ContractualPlanningSlotsGrid;
